'use strict';

angular.module('mobile-apps').controller('ConnectIosAppstoreModalController', [
	'$scope',
	'EventTracker',
	'ModalData',
	'AppstoreIntegration',
	'Utilities',
	'$modalInstance',
	'$q',
	function (
		$scope,
		EventTracker,
		ModalData,
		AppstoreIntegration,
		Utilities,
		$modalInstance,
		$q
	) {

		$scope.data = {
			isLoading: false,
			appName: '',
			email: '',
			password: ''
		};



		/**
		 * Uses the data entered by the user to generate a new access token
		 */
		$scope.connectStore = function () {
			var sendData = {
				mobileAppId: ModalData.mobileApp._id,
				storeType: 'ios',
				appName: $scope.data.appName,
				email: $scope.data.email,
				password: $scope.data.password
			};

			$scope.data.isLoading = true;

			AppstoreIntegration.connect(sendData).$promise
				.then(
					function(data) {
						$scope.data.isLoading = false;

						Utilities.showMessage('Success', 'Successfully connected to Apple App Store!', 'success');
						$modalInstance.close({success: true});
					}
				)
				.catch(
					function(error) {
						$scope.data.isLoading = false;
						Utilities.showMessageErrorResponse(error);
					}
				);
		};


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};

	}
]);

